/**
 * @memberof module:compressed-json
 * @function bind
 * @param {Object} config
 * @param {string[]} [config.reservedKeys=[]] - reservedKeys to bind
 * @param {string[]} [config.reservedValues=[]] - reservedValues to bind
 */
'use strict';

import compress from './compress';
import decompress from './decompress';
/** @lends module:compressed-json.bind */

function bind() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _config$reservedKeys = config.reservedKeys,
      reservedKeys = _config$reservedKeys === void 0 ? [] : _config$reservedKeys,
      _config$reservedValue = config.reservedValues,
      reservedValues = _config$reservedValue === void 0 ? [] : _config$reservedValue;

  var boundCompress = function boundCompress(src) {
    return compress(src, {
      reservedKeys: reservedKeys,
      reservedValues: reservedValues
    });
  };

  boundCompress.toString = function (compressed) {
    return JSON.stringify(boundCompress(compressed));
  };

  var boundDecompress = function boundDecompress(src) {
    return decompress(src, {
      reservedKeys: reservedKeys,
      reservedValues: reservedValues
    });
  };

  boundDecompress.fromString = function (compressedString) {
    return boundDecompress(JSON.parse(compressedString));
  };

  return {
    compress: boundCompress,
    decompress: boundDecompress
  };
}

export default bind;